<template>
    <div class="profile-card">
        <div v-if="!hasData" class="profile-card-header">{{ card.title }}</div>
        <div class="profile-card-body">
            <div v-if="hasData">
                <component :is="card.component" :perspective="perspective"></component>
            </div>
        </div>
    </div>
</template>

<script>
import customFields from '../../customFields.vue';
import userDefinedFieldsViewer from '../../udf/userDefinedFieldsViewer.vue';

export default {
    components: {
        customFields,
        userDefinedFieldsViewer,
    },
    props: {
        card: { type: Object, required: true },
        psp: { type: String, required: true },
        recordId: { type: [Number, String], required: true },
    },
    computed: {
        hasData() {
            return this.card.type === 'component' && (this.card.component === 'customFields' || this.card.component === 'userDefinedFieldsViewer');
        },
        perspective() {
            const pspMap = {
                vol: 'volunteers',
                opp: 'opportunities',
            };
            return pspMap[this.psp] ?? this.psp;
        }
    }
};
</script>
